import React from 'react';
import { Navigate, Outlet, useLocation, useParams } from 'react-router-dom';

const ALLOWED_EXACT = new Set([
  'login',
  'order-type',
  'menu',
  'cart',
  'confirmation',
  'orders',
]);

function isAllowedSubPath(subPath: string): boolean {
  if (!subPath) return false;
  if (ALLOWED_EXACT.has(subPath)) return true;
  if (/^menu\/[^/]+$/.test(subPath)) return true;
  if (/^orders\/[^/]+$/.test(subPath)) return true;
  return false;
}

const KioskRouteGuard: React.FC = () => {
  const { appName } = useParams<{ appName: string }>();
  const location = useLocation();
  const match = location.pathname.match(/^\/kiosk\/[^/]+\/(.+)$/);
  const subPath = (match?.[1] || '').replace(/\/+$/, '');

  if (!appName) {
    return <Navigate to="/" replace />;
  }

  if (!isAllowedSubPath(subPath)) {
    // Bare /kiosk/:appName (session start) → OTP login, not menu
    return <Navigate to={`/kiosk/${encodeURIComponent(appName)}/login${location.search}`} replace />;
  }

  return <Outlet />;
};

export default KioskRouteGuard;
